<template>
    <v-row no-gutters class="pb-4">
        <v-col cols="7">
            <h5 v-text="setting.label" style="opacity: 0.9;" />
            <p v-text="setting.description" class="ma-0 mr-2" style="opacity: 0.8; white-space: pre-line;" />
        </v-col>
        <v-col cols="5">
            <v-skeleton-loader v-if="!loaded" type="list-item">
            </v-skeleton-loader>
            <slot v-else name="component">
                <component :is="getComponentName(setting)" v-model="setting.value" :label="setting.label" externaledit
                    :rules="setting.rules" :clearable="settingIsClearable(setting)" :loading="setting.loading" hideIcon
                    @input="onSettingInput(setting)" @blur="onSettingBlur(setting)">
                </component>
            </slot>
        </v-col>
    </v-row>
</template>


<script>
import Vue from 'vue';
import JobStatusSelect2 from "@/components/Inputs/EntityDropdowns/JobStatusSelect2.vue";
import JobTypeSelect from "@/components/Inputs/EntityDropdowns/JobTypeSelect.vue";
import JobPrioritySelect from "@/components/Inputs/EntityDropdowns/JobPrioritySelect.vue";
import JobCategorySelect2 from "@/components/Inputs/EntityDropdowns/JobCategorySelect2.vue";
import CustomerSelect2 from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import ArticleSelect2 from "@/components/Inputs/EntityDropdowns/ArticleSelect2.vue";
import WarehouseSelect2 from "@/components/Inputs/EntityDropdowns/WarehouseSelect2.vue";
import MintesOfHourSlider from "@/components/Inputs/MintesOfHourSlider.vue";
import SettingsMixin from './SettingsMixin';

export default {
    name: "SettingRow",
    props: {
        loaded: Boolean,
        fetchLoading: Boolean,
        setting: Object,
    },
    components: {
        JobStatusSelect2,
        JobTypeSelect,
        JobPrioritySelect,
        JobCategorySelect2,
        CustomerSelect2,
        ArticleSelect2,
        WarehouseSelect2,
        MintesOfHourSlider,
    },
    mixins: [SettingsMixin],

    data() {
        return {};
    },

    methods: {
        // called on every input change
        onSettingInput(setting) {
            //console.log('on input')
            if (this.fetchLoading || !this.settingsValueHasChanged(setting)) {
                return;
            }

            Vue.set(setting, '_dirty', true);

            // For text-like fields: do NOT autosave while typing, wait for blur.
            const componentName = this.getComponentName(setting);
            if (componentName === 'QTextField' || componentName === 'QTextArea') {
                return;
            }

            // For selects/etc: debounce saves (user might change again quickly)
            this.$emit('debounceSave')
        },

        //blur = immediate save of this one setting (no delay)
        onSettingBlur(setting) {
            //console.log('on blur')
            if (this.fetchLoading || !this.settingsValueHasChanged(setting)) {
                return;
            }

            if (this.getComponentName(setting) === 'QSwitchInput') {
                return;
            }

            Vue.set(setting, '_dirty', true);

            if (!this.isSettingValid(setting)) {
                return; // leave it dirty, user sees validation error
            }

            // Save only this setting immediately
            this.$emit('instantSave', [setting])
        },
    },

    computed: {},

    watch: {},
};
</script>


<style lang="scss" scoped></style>